document.addEventListener('DOMContentLoaded', function(){
    const allTabTitles = document.querySelectorAll('button[role="tab"]');


    let tabActive  = document.querySelector('.tab-title.active ');
    let contentActive = document.querySelector('.content.active');

    allTabTitles.forEach(element => {
        element.addEventListener('click', (e) => {
            const id = element.getAttribute('aria-controls');
            const content = document.querySelector(`#${id}`);

            console.log(content);
            tabActive.classList.remove('active');
            contentActive.classList.remove('active');
            contentActive.classList.add('hidden');

            element.classList.add('active');
            content.classList.remove('hidden');
            content.classList.add('active');
            tabActive = element;
            contentActive = content;
        });
    });
});